<div class="w-100 h-100 d-flex flex-column">
  <ngx-heka-heka-navigation-container appTitle="{{'APPS.OMS_TOOL.TITLE'|translate}}"
                                    appImageLink="{{'assets/images/heka-logo-symbols/oms.svg'}}"
                                    startPage="/pages"
                                    collapseText="{{'MENU.COLLAPSE'|translate}}"
                                    [accountMenu]="accountMenu"
                                    [helpLink]="env.links.help"
                                    [loading]="(loadingService.getLoading().asObservable() |async)||false"
                                    (onDomainChange)="domainHandlerService.switchDomainAndReload($event.domainId)">
  <ngx-heka-no-app-access class="mx-auto" [title]="'OAUTH.NO_ACCESS.TITLE'|translate" [description]="description">
    <button mat-flat-button color="primary"  (click)="goToMHP()">
      {{ 'OAUTH.NO_ACCESS.BACK_TO_DASHBOARD' | translate }}
    </button>
  </ngx-heka-no-app-access>
</ngx-heka-heka-navigation-container>
</div>